import { render, staticRenderFns } from "./AddRealmUser.vue?vue&type=template&id=235cd2d9&"
import script from "./AddRealmUser.vue?vue&type=script&lang=js&"
export * from "./AddRealmUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports